import Vue from "vue";
import App from "./App.vue";
import VModal from "vue-js-modal";
require("dotenv").config();
import "normalize.css/normalize.css"; // a modern alternative to CSS resets
import Element from "element-ui";
import "./styles/element-variables.scss";

import "@/styles/index.scss"; // global css
import store from "./store";
import router from "./router";
import locale from "element-ui/lib/locale/lang/en";
import VueOtp2 from "vue-otp-2";
import VueClipboard from "vue-clipboard2";
import "vue-tel-input/dist/vue-tel-input.css";
import SocketUtils from "./utils/SocketUtils";
import VueMixpanel from "vue-mixpanel";

VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);
Vue.use(VModal);
Vue.use(Element, { locale });
SocketUtils.init();
Vue.use(VueOtp2);
Vue.use(VueMixpanel, {
  token: "04b08284cb70933e6add220c65f118bf",
});

Vue.config.productionTip = false;
Vue.config.silent = true;

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
